const featureConfig: Record<string, boolean> = {
  ConsoleLogs: true,
  AudioVideoCall: true,
  DFM: true,
  Chat: true,
  CARExt: false,
  ContentOptimizer: false,
  areaSelection: false,
  Lattice: false,
  MaterialThickness: true,
  debugChat: false,
  testPart: true,
  sellerStats: true,
  screenshots: true,
};

// Apply URL-driven overrides at module load time
if (typeof window !== 'undefined') {
  const _params = new URLSearchParams(window.location.search);

  if (_params.get('esid')) {
    featureConfig.Tender = false;
  }

  if (_params.get('source')) {
    featureConfig.Chat = false;
  }
}

export type UrlParam = { name: string; param: string };

export const isFeatureEnabled = (featureName: string): boolean =>
  Boolean(featureConfig[featureName]);

export const setFeaturesFromUrlParams = (urlParams: UrlParam[]): void => {
  for (const { name, param } of urlParams) {
    if (featureConfig[name] !== undefined) {
      featureConfig[name] = param.toLowerCase() !== 'false';
    }
  }
};

export const getFeatures = (): string[] => Object.keys(featureConfig);
